<div class="status-badge">
  <span class="status" [ngClass]="order.status">{{ getDisplayStatus() }}</span>
</div>
